<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <!--ricerca -->
        <div class="card-title px-2 pt-2 w-100">
          <div class="row">
            <div class="col-lg-3 col-12">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-lg-9 col-12 text-right" [ngClass.sm]="'mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <a routerLink="/dashboard/list-location/add" class="btn btn-outline-primary" has_capability="create_customer_address">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 180"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredAddresses"
            [sorts]="[
              { prop: 'client.name', dir: 'asc' },
              { prop: 'label', dir: 'asc' }
            ]"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="client.name" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" src="{{ row.client?.logo }}" class="mr-1 rounded-circle contain" width="32" height="32" [alt]="row.client?.name" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row?.client?.business_name[0] }}</div>
                  </div>
                  <a routerLink="/dashboard/customer/{{ row.client.id }}" *ngIf="row.client && row.client.name">{{ row.client.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'LABEL' | translate" prop="label" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.label }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ROAD' | translate" prop="street" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.street }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ZIP_CODE' | translate" prop="zipcode" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.zipcode ? row.zipcode : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'MENU.CITIES' | translate" prop="city" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.city || row.external_city }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ADDRESS_DISTANCE' | translate" prop="km" [width]="30" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.km }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" prop="azioni" [width]="30" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_customer_address">
                    <a routerLink="/dashboard/list-location/edit/{{ row.id }}" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </a>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" has_capability="delete_customer_address">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="client.name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-10">
                    <div class="d-flex align-items-center">
                      <img #image (error)="image.hidden = true" src="{{ row.client.logo }}" class="mr-1 rounded-circle" width="32" height="32" [alt]="row.client.name" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row?.client?.business_name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/list-location/edit/{{ row.id }}" *ngIf="row.client && row.client.name">{{ row.client.name }}</a>
                    </div>
                    <div>{{ row.label }}</div>
                    <div>{{ row.street }}</div>
                    <div>{{ row.zipcode ? row.zipcode : "-" }}</div>
                    <div>{{ row.city || row.external_city }}</div>
                  </div>
                  <div class="col-2 d-flex flex-column justify-content-center pl-0">
                    <button class="bg-transparent border-0 text-secondary mb-1" has_capability="edit_customer_address">
                      <a routerLink="/dashboard/list-location/edit/{{ row.id }}" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" has_capability="delete_customer_address">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
